import { IFlow } from "./AppRequest";
import { IPublicationPackViewModel, ITitle, IVersion, IVersionMeta } from "./DashboardModels";

export interface IGetAllTitlesRequest {
  ExcludeTitles: number[];
  PublisherId: number;
  HideInactiveTitles: boolean;
}
export interface IGetAllTitlesR {
  Titles: ITitle[];
}
export interface IFlowTitlesRequest extends IFlow {
  ExcludeTitles: number[];
  PublisherId: number;
  HideInactiveTitles: boolean;
}
export interface IFlowVersionsForTitleRequest extends IFlow {
  TitleId: number;
  PublisherId: number;
  HideInactiveVersions: boolean;
}
export interface IGetTitle {
  TitleId: number;
}
export interface IGetTitleR {
  Title: ITitle;
}
export interface IGetVersionMeta {
  Version: IVersion;
}
export interface IGetVersionMetaR {
  VersionMeta: IVersionMeta;
}
export interface IUpdateVersionMeta {
  Version: IVersion;
  VersionMeta: IVersionMeta;
}
export interface IUpdateVersionMetaR {}
export interface IGetPublicationPacks {
  PublisherId: number;
}
export interface IGetPublicationPacksR {
  PublicationPacks: IPublicationPackViewModel[];
}
export interface IInsertOrUpdateTitle {
  Title: ITitle;
}
export interface IInsertOrUpdateTitleR {
  Title: ITitle;
}

export interface IInsertOrUpdateVersion {
  Version: IVersion;
  VersionMeta: IVersionMeta;
}
export interface IInsertOrUpdateVersionR {
  Version: IVersion;
}

export interface IDeleteTitle {
  Title: ITitle;
}
export interface IDeleteTitleR {}

export interface ITriggerProfessorProcessing {
  VersionRef: string;
}
export interface ITriggerProfessorProcessingR {}

export interface IAddSplashPage {
  TitleId: number;
  SplashData: string;
  SplashWidth: number;
  SplashHeight: number;
}
export interface IDeleteSplashPage {
  TitleId: number;
  SplashId: number;
}
export interface IDeleteSplashPageR {}

export interface IGetSplashPages {
  TitleId: number;
}

export interface IGetSplashPagesR {
  SplashPages: ISplashImage[];
}

export interface IAddSplashPageR {}

export interface ISplashImage {
  Id: number;
  ImageData: string;
  Width: number;
  Height: number;
  Orientation: PubImageOrientation;
}
export enum PubImageOrientation {
  // The following three values are copies of Common\Utility\Orientation.  These need be resolved so there's just one definition
  Undefined = 0, // no database record should have this value
  Portrait = 1,
  Landscape = 2,

  // extend this set: orientation becomes a selector of image types (orientation, size, ...)
  PortraitThumb = 3,
  LandscapeThumb = 4,
}
